// Angular Imports
import { NgModule } from '@angular/core';
import { CheckinConfirmationNoModule } from './checkin-confirmation-no/checkin-confirmation-no.module';
import { CheckinTicketNoModule } from './checkin-ticket-no/checkin-ticket-no.module';
import { ConnectionModule } from './connection/connection.module';
import { HelpModalDirective } from './help-modal.directive';
import { MyTripsConfirmationNosModule } from './mytrips-confirmation-no/mytrips-confirmation-no.module';
import { MyTripsTicketNoModule } from './mytrips-ticket-no/mytrips-ticket-no.module';
import { RefundableFlightsModule } from './refundable-flights/refundable-flights.module';
import { ShowPriceInModule } from './show-price-in/show-price-in.module';
import { MeetingCodeModule } from './meeting-code/meeting-code.module';
import { CabinExperiencesModule } from './cabin-experiences/cabin-experiences.module';
import { YoungAdultPaxModule } from './young-adult-pax/young-adult-pax.module';
import { MyTripsConfirmationNoComponent } from './mytrips-confirmation-no/mytrips-confirmation-no.component';
import { ShowPriceInComponent } from './show-price-in/show-price-in.component';
import { RefundableFlightsComponent } from './refundable-flights/refundable-flights.component';
import { MeetingCodeComponent } from './meeting-code/meeting-code.component';
import { CabinExperiencesComponent } from './cabin-experiences/cabin-experiences.component';
import { YoungAdultPaxComponent } from './young-adult-pax/young-adult-pax.component';
import { MyTripsTicketNoComponent } from './mytrips-ticket-no/mytrips-ticket-no.component';
import { CheckinTicketNoComponent } from './checkin-ticket-no/checkin-ticket-no.component';
import { CheckinConfirmationNoComponent } from './checkin-confirmation-no/checkin-confirmation-no.component';
import { ConnectionComponent } from './connection/connection.component';

@NgModule({
  imports: [
    CheckinConfirmationNoModule,
    CheckinTicketNoModule,
    ConnectionModule,
    MeetingCodeModule,
    CabinExperiencesModule,
    YoungAdultPaxModule,
    RefundableFlightsModule,
    ShowPriceInModule,
    MyTripsConfirmationNosModule,
    MyTripsTicketNoModule
  ],
  declarations: [HelpModalDirective],
  exports: [HelpModalDirective]
})
export class HelpModalModule {}
